<template>
  <div>
    <div class="flex flex-col items-center max-w-lg px-8 mx-auto mt-5 mb-3 border rounded md:px-16 md:my-10 border-sc-gray-light shadow-sc-secondary">
      <div class="flex flex-col items-center justify-start w-full gap-4 mt-6 mb-10 bg-white">
        <div class="w-full md:mb-1 items-left">
          <h1
            class="text-xl leading-9 text-left md:mb-2 md:text-3xl text-primary"
          >
            {{ accountConnected ? $t('message.onboarding.fintocStep.accountConnected') :
              $t('message.onboarding.fintocStep.waitingAccount') }}
          </h1>
          <div
            v-if="!accountConnected"
            class="mt-4 text-sm"
          >
            <p>
              {{ $t('message.onboarding.fintocStep.connectionInfo') }}
            </p>
            <a
              href="https://fintoc.com/cl/seguridad"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('message.onboarding.fintocStep.knowMore') }}
            </a>
          </div>
        </div>
        <fintoc-widget
          v-if="showWidgetButtons || !accountConnected"
          :entity-id="entityId"
          @onSuccess="onSuccess"
        />
        <navigation-buttons
          :is-form-valid="accountConnected"
          :show-back="false"
          :show-skip="true"
          :skip-button-text="$t('message.onboarding.fintocStep.skipButtonText')"
          @next="$emit('next')"
        />
        <button
          @click="showWidgetButton"
          v-if="accountConnected && !showWidgetButtons"
          class="inline-block px-6 py-1 text-xs font-bold leading-5 text-center text-gray-400 uppercase outline-none background-transparent focus:outline-none"
        >
          {{ $t('message.onboarding.fintocStep.connectAnotherAccount') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapWritableState } from 'pinia';
import { useOnboardingWizardStore } from '../../stores/onboarding-wizard';
import fintocWidget from '../bank-accounts/fintoc-widget.vue';
import NavigationButtons from './navigation-buttons.vue';

export default {
  components: { fintocWidget, NavigationButtons },
  props: {
    entityId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showWidgetButtons: false,
    };
  },
  computed: {
    ...mapWritableState(useOnboardingWizardStore, ['fintocAccountConnected']),
    accountConnected: {
      get() {
        return this.fintocAccountConnected;
      },
    },
  },
  methods: {
    showWidgetButton() {
      this.showWidgetButtons = true;
    },
    onSuccess() {
      this.fintocAccountConnected = true;
      this.showWidgetButtons = false;
    },
  },
};
</script>
